import { MaxLengthDisplayBase } from '../../shared/MaxLengthDisplayBase';

interface Props {
    length: number;
    maxLength: number | undefined;
    hasFocus: boolean;
}

export const HtmlControlMaxLength = ({
    length,
    maxLength,
    hasFocus,
}: Props): React.ReactElement => {
    return (
        <MaxLengthDisplayBase
            hasFocus={hasFocus}
            length={length}
            maxLength={maxLength}
            isGreater={length > (maxLength || 0)}
        />
    );
};
